import { handleResponse, handleError } from "./apiUtils";
import { BASE_URL } from "../utils/connectApi";

export function getUser(token) {
  return fetch(BASE_URL + `user`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUserByName(name) {
  return fetch(BASE_URL + `/profile/${name}`)
    .then(handleResponse)
    .catch(handleError);
}

export function fetchUserByEmail(token, email) {
  return fetch(BASE_URL + `user/email/${email}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUserProfile(token) {
  return fetch(BASE_URL + `profile`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUserProfileById(id) {
  return fetch(BASE_URL + `profile/${id}`, {
    method: "GET",
  })
    .then(handleResponse)
    .catch(handleError);
}

export function saveRecipeToProfileFavorites(recipeId, favorite, token) {
  return fetch(BASE_URL + `profile/favorites`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ recipe: recipeId, favorite }),
  })
    .then(handleResponse)
    .catch(handleError);
}
